import type { ReactNode } from 'react';

interface ContenedorConfiguracionProps {
  children: ReactNode;
}

export function ContenedorConfiguracion({ children }: ContenedorConfiguracionProps) {
  return (
    <div className="max-w-7xl mx-auto p-6 space-y-6">
      {children}
    </div>
  );
}

export function ContenedorForm({ children }: ContenedorConfiguracionProps) {
  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6">
      {children}
    </div>
  );
}

export function ContenedorModulo({ children }: ContenedorConfiguracionProps) {
  return (
    <div className="p-6 space-y-6">
      {children}
    </div>
  );
}

export function ContenedorNuevoComprobante({ children }: ContenedorConfiguracionProps) {
  return (
    <div className="max-w-7xl mx-auto pt-2 px-6 pb-24 space-y-4">
      {children}
    </div>
  );
}